import { FC } from 'react';
import { useTranslation } from 'next-i18next';

import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';
import { PageTitle } from '@phoenix/design-system/frontend/ui/page-title/page-title';
import { useLinksByUserLocale } from '../../feature/global-links/use-links-by-user-locale';

import { PhoenixImage } from '../assets/phoenix-image';
import * as React from 'react';

const logo = getDesignSystemIcon('stihl_logo.svg');
const rightArrowIcon = getDesignSystemIcon('icon-arrow-right-16.svg');

export interface PagNotAvailableProps {
  headline: string;
  subHeadline: string | React.ReactElement;
  imageSrc?: string;
  linkId?: string;
}

export const PageNotAvailable: FC<React.PropsWithChildren<PagNotAvailableProps>> = ({
  headline,
  subHeadline,
  imageSrc = 'not-available-background.png',
  linkId = '',
}) => {
  const { t } = useTranslation('shared');
  const { data: links } = useLinksByUserLocale([linkId], !!linkId);

  const linkUrl = links?.[linkId]?.url?.toLowerCase();

  return (
    <div className="relative flex h-[80vh] justify-center p-24 tablet:items-center mobileOnly:px-12 miniTabletOnly:px-12">
      <div className="inset-0">
        <PhoenixImage assetsKey={['assets-core']} src={imageSrc} layout="fill" objectFit="cover" staticTags={['imagesCore']} />
      </div>
      <div className="absolute right-0 top-0 tablet:right-8 tablet:top-8">
        <img src={logo} alt="Stihl logo" className="h-16" />
      </div>
      <div className="z-10 flex flex-grow items-center justify-center mobileOnly:items-start miniTabletOnly:items-start">
        <div className="w-full max-w-[41rem] bg-primary-white p-8 mobileOnly:p-6 miniTabletOnly:p-6">
          <PageTitle>{headline}</PageTitle>
          <p className="whitespace-pre-line stihl-text-body-default-reg">{subHeadline}</p>
          {linkUrl && (
            <a href={linkUrl} className="group mt-8 flex cursor-pointer items-center stihl-text-body-default-bold">
              <span>{t('shared_error_404_content_button')}</span>
              <svg className="ml-1 mt-0.5 h-3 w-3 text-primary-black transition-all group-hover:ml-2">
                <use xlinkHref={`${rightArrowIcon}#img`} />
              </svg>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};
